import {Component, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '@Common/widgets/general/data-table';
import {Dossiers, StateEnum} from '../../common/services';
import {DatePipe} from '@angular/common';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {FileSaverService, IndividuService, PubSubService} from '@Common/core/services';
import {DarDossiersService} from '../../common/services/dossiers/dossiers.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {SnackBarToastyService} from '@Common/widgets/general/snack-bar';
import {ModaleContainerDossierComponent} from '../consultation/modale-container/modale-container-dossier.component';
import {environment} from '@Env/environment';
import {SlugifyPipe} from '@Common/widgets/pipes';

import {finalize} from 'rxjs/operators';
import {noop} from 'rxjs';
import {ListDossiersHelper} from '../../common/components/list-dossiers-helper';
import {SubSink} from '@Common/core/utils/subsink';

/**
 * Liste des dossiers "demandeur", du connecté
 */
@Component({
  selector: 'app-list-dossiers',
  templateUrl: './list-dossiers.component.html',
  styleUrls: ['./list-dossiers.component.scss']
})
export class ListDossiersComponent extends ListDossiersHelper  implements OnInit, OnDestroy {
  urlList = `${environment.baseUrl}/dar/dossiers/mes_demandes/`;
  subSink = new SubSink();

  columns: ColumnDataTable[] = [
    {
      columnDef: 'iscontact', header: '',
      display: (dossier: Dossiers) => this._colorContactBackground(dossier),
      sort: false, flex: 3
    },
    { columnDef: 'state', header: 'Etape',
      display: (dossier: Dossiers) => {
        const classType = this.getClassFromType(dossier.state);
        return `<small><span class="${classType}">${this.getStateLabel(dossier)}</span></small>`;
      },
      tooltip: (row: Dossiers) => {
        return row.state_title;
      },
      sort: true,  hidden: false, flex: 10
    },
    { columnDef: 'reference', header: 'Référence', display: (dossier: Dossiers) => {
        return dossier.reference;
      } , sort: true, truncate: true, flex: 10 },
    { columnDef: 'intitule', header: 'Intitulé de poste',
      display: (dossier: Dossiers) => this.displayIntitulePoste(dossier),
      tooltip: (dossier: Dossiers) => this.displayIntitulePoste(dossier),
      sort: false, truncate: true, flex: 25 },
    {
      columnDef: 'dt_updated', header: 'Modifié le', display: (dossier: Dossiers) => {
        const dp: DatePipe = new DatePipe(this.locale);
        return `<strong>${dp.transform(`${dossier.dt_updated}`, 'dd/MM/yyyy')}</strong>`;
      },
      tooltip: (dossier) => {
        if (dossier) {
          const dpStart: DatePipe = new DatePipe(this.locale);
          return `modifié le ${dpStart.transform(`${dossier.dt_updated}`, 'dd/MM/yyyy à H:mm')},
                  créé le ${dpStart.transform(`${dossier.dt_created}`, 'dd/MM/yyyy à H:mm')}`;
        }

        return '';
      },
      sort: true
    },
  ];

  actions: ActionDataTable[] = [
    { label: 'Supprimer', tooltip: 'Supprimer ce dossier', icon: 'delete',
      hidden: (row: Dossiers) => this.hiddenActionDelete(row),
      tooltipfct: (row: Dossiers) => row.state !== StateEnum.demande ? '' : 'Supprimer ce dossier',
      click: (row: Dossiers) => row.state === StateEnum.demande ? this.supprimer(row) : noop(),
      iconcolorfct: (row: Dossiers) => row.state !== StateEnum.demande ? '' : 'warn',
      iconfct: (row: Dossiers) => row.state !== StateEnum.demande ? '' : 'delete',
      flex: 10 },

    { label: 'Modifier', tooltip: 'Modifier ce dossier', icon: 'edit', iconcolor: 'accent',
      hidden: (row: Dossiers) => ! this.canEdit(row),
      tooltipfct: (row: Dossiers) => this.canEdit(row) ? 'Modifier ce dossier' : '',
      click: (row: Dossiers) => this.canEdit(row) ? this.modifier(row) : noop(),
      iconfct: (row: Dossiers) => this.canEdit(row) ? 'edit' : ''
    },

    { label: 'Visualiser', tooltip: 'Visualiser cette demande',  icon: 'visibility',
      click: (row: Dossiers) => this._visualiser(row),
      iconcolor: 'accent',
    },

    { label: 'Modale', tooltip: 'Visualiser en fenêtre cette demande',  icon: 'zoom_in',
      click: (row: Dossiers) => this._visualiser_modale(row),
      iconcolor: 'accent',
    },

    { label: 'Export', tooltip: 'Export PDF de cette demande',  icon: 'picture_as_pdf',
      click: (row: Dossiers) => this.exportPdf(row),
      iconcolor: 'accent',
    },
  ];

  dsDossiers: MatDataSourceGeneric<Dossiers> = new MatDataSourceGeneric<Dossiers>();
  exludeStatesDefault = [StateEnum.clos, StateEnum.archived];
  filterStatesNotIn = 'states_not_in';
  filterByState = 'by_state';
  extraParams: Map<string, string> = new Map<string, string>([
    [this.filterStatesNotIn, this.exludeStatesDefault.join(',')]
  ]);
  allStatus = false;
  @ViewChild(DataTableComponent, { static: true }) dataTable: DataTableComponent;
  isContact = false;
  hasDar = false;
  loadingInProgress = true;
  constructor(@Inject(LOCALE_ID) private locale: string,
              private fileService: FileSaverService,
              public individuSvc: IndividuService,
              private pubSubSvc: PubSubService,
              public dossiersService: DarDossiersService,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router,
              public snackBar: MatSnackBar,
              public snackSvc: SnackBarToastyService) {
    super(dialog, individuSvc, snackSvc, dossiersService);
    this.dsDossiers.daoService = dossiersService;
  }

  ngOnInit() {
    this.subSink.sink = this.dsDossiers.listData$.subscribe(_dars => this.isContact = this._isConnectedIsInContact(_dars));
    this.subSink.sink = this.dsDossiers.listCount$.subscribe(_cnt => this.hasDar = _cnt > 0);
    this.subSink.sink = this.dsDossiers.loading$.subscribe(_loading => this.loadingInProgress = _loading);
  }
  onOnOffAllStatutAndFilter(allStatus: boolean) {
    this.allStatus = allStatus;
    if (allStatus) {
      this.extraParams.delete(this.filterStatesNotIn);
    } else {
      this.extraParams.delete(this.filterByState);
      this.extraParams.set(this.filterStatesNotIn, this.exludeStatesDefault.join(','));
    }
    this.dataTable.reload();
  }
  onStatusChanged(status: StateEnum) {
    if (status) {
      this.extraParams.delete(this.filterStatesNotIn);
      this.extraParams.set(this.filterByState, status.toString());
    } else {
      this.extraParams.delete(this.filterByState);
    }
    this.dataTable.reload();
  }
  displayIntitulePoste(dossier: Dossiers): string {
    if (dossier.intitule_poste_autre) {
      return dossier.intitule_poste_autre;
    }
    return dossier.intitule_obj?.label || '';
  }
  /**
   * On cache le bouton de suppression si le dossier n'est pas en état "demande" (création) et s'il ne lui appartient pas
   * @param {Dossiers} dossier
   */
  hiddenActionDelete(dossier: Dossiers): boolean {
    return (dossier.state !== StateEnum.demande && dossier.individu.uid === this.connecte.uid);
  }
  canEdit(dossier: Dossiers) {
    return dossier.state === StateEnum.demande;
  }

  exportPdf(dossier: Dossiers) {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.dossiersService.exportPdfDemandeur(dossier)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe((_data) => {
      const slug = new SlugifyPipe();
      const ref = slug.transform(dossier.reference, 'upper');
      this.fileService.FileSave(_data, `EXPORT_DEMANDE_DAR_${ref}`, 'pdf');
    });
  }

  private _visualiser_modale(dossier: Dossiers): void {
    const data = {
      dossierId: dossier.uuid,
      byModal: true,
    };
    const modalDossier = this.dialog.open(ModaleContainerDossierComponent, {data: data});
    modalDossier.updateSize('950px', '800px');
    modalDossier.updatePosition({top: '50px'});
  }

  private _visualiser(dossier: Dossiers): void {
    this.router.navigate(['consultation', {id: dossier.uuid}], {relativeTo: this.route.parent});
  }

  public ajouter() {
    this.router.navigate(['edit-etapes', {id: 0}]);
  }

  public getStateLabel(dossier: Dossiers) {
    return this.dossiersService.getStateTitle(dossier);
  }

  public getClassFromType(state: StateEnum) {
    return `dar-${state}`;
  }

  modifier(dossier: Dossiers): void {
    this.router.navigate(['/edit-etapes', {id: dossier.uuid}], {relativeTo: this.route.parent});
  }

  supprimer(dossier: Dossiers): void {
    this.confirmAndDeleteDossier(dossier, this.dataTable, 'delete');
  }

  /**
   * Couleur pour indiquer que pour telle DAR, il a été mis en contact
   * @param {Dossiers} dossier
   * @private
   */
  private _colorContactBackground(dossier: Dossiers) {
    if (dossier.individu.uid !== this.connecte.uid) {
      return `<small><span class="contact-dar">&nbsp;&nbsp;&nbsp;&nbsp;</span></small>`;
    }
    return '';
  }

  /**
   * Est-il contact d'au moins une DAR ?
   * @param {Dossiers[]} dars
   * @private
   */
  private _isConnectedIsInContact(dars: Dossiers[]) {
    return dars.some(_dar => _dar.contacts_obj.find(_contact => _contact.uid === this.connecte.uid));
  }
  ngOnDestroy(): void {
   this.subSink.unsubscribe();
  }
}
